/* eslint-disable no-unused-vars */
export enum HealthSummaryQuestionMapping {
  consultWay='Hooray - last question!  How would you like to do your telehealth consult?',
  howHear='How did you hear about us?',
  healthConcern='Please provide a short summary of your health concerns below to assist us with diagnosis and treatment.',
  hasDept='Do you have a White or Gold Department of Veterans\' Affairs (DVA) card?',
  gpName='How did you hear about our service:',
  medibankMemberNo="What's your Medibank Member No.?"
}
